"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var URLSearchParams = require("url-search-params");
var URL = require("url");
var ApplyUrl = (function () {
    function ApplyUrl() {
    }
    ApplyUrl.prototype.get = function (applyUrl, current) {
        var apply = URL.parse(applyUrl);
        var applyParams = new URLSearchParams(apply.search);
        var currentParams = new URLSearchParams(current.search);
        var keys = currentParams.keys();
        var key = keys.next();
        while (!key.done) {
            if (applyParams.has(key.value)) {
                applyParams.set(key.value, currentParams.get(key.value));
            }
            else {
                applyParams.append(key.value, currentParams.get(key.value));
            }
            key = keys.next();
        }
        if (current.hash && current.hash.indexOf('&') > -1) {
            var hashQueryArray = current.hash.split('&');
            hashQueryArray.shift();
            var hashQueryStrings = hashQueryArray.join("&");
            var hashParams = new URLSearchParams(hashQueryStrings);
            var hashKeys = hashParams.keys();
            var hashKey = hashKeys.next();
            while (!hashKey.done) {
                if (!applyParams.has(hashKey.value)) {
                    applyParams.append(hashKey.value, hashParams.get(hashKey.value));
                }
                hashKey = hashKeys.next();
            }
        }
        if (!applyParams.has("jobboardid")) {
            applyParams.append("jobboardid", 0);
        }
        apply.search = applyParams.toString();
        apply.query = applyParams.toString();
        return apply;
    };
    return ApplyUrl;
}());
exports.ApplyUrl = ApplyUrl;



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/f257358f111b2299/src/shared/ApplyUrl.ts
// module id = 301
// module chunks = 0